// Import necessary Material-UI components
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// Import necessary custom components
import { ItemDetails, ApprovalDetails, ViewImage } from "./";
import { SupplierDetails } from "../../sampleControl";
// Import lodash utility function
import _ from "lodash";

export function ItemDetailsDropDown(cellValues, clickedIndex, sampleRequestID) {
  return (
    <Box>
      {/*  Conditionally render the item's details on whether the row is expanded */}
      <div
        style={{
          display: cellValues.id === clickedIndex ? "none" : "flex",
        }}
      >
        {cellValues.value}
      </div>
      {/* Use the Collapse component to animate the expansion and collapse of the dropdown */}
      <Collapse in={cellValues.id === clickedIndex}>
        {/* Render the ItemDetails component with the item's details */}
        <ItemDetails
          cellValues={_.omit(cellValues.row, [
            "id",
            "_id",
            "supplierList",
            "HODApproval",
            "execChefApproval",
            "userApproval",
            "productImages",
            "requesterSampleImage",
            "editOrDeleteItem",
          ])}
        />
        {/*  Conditionally render the reference image(s) if they exist */}
        {cellValues.row.requesterSampleImage && (
          <Grid
            container
            style={{
              fontSize: "14px",
              marginBottom: "15px",
            }}
          >
            <Grid item xs={12} sm={5}>
              <span>Reference Image(s):</span>
            </Grid>
            <Grid item xs={12} sm={7}>
              {Array.isArray(cellValues.row.requesterSampleImage) ? (
                cellValues.row.requesterSampleImage.map((image, index) => {
                  return (
                    <ViewImage
                      productImage={image}
                      key={index}
                      altIndex={index}
                    />
                  );
                })
              ) : (
                <ViewImage productImage={cellValues.row.requesterSampleImage} />
              )}
            </Grid>
          </Grid>
        )}
        {/* Conditionally render supplier details if they exist */}
        {cellValues.row.supplierList && (
          <SupplierDetails
            supplierValues={cellValues.row.supplierList}
            sampleRequestID={sampleRequestID}
            sampleItemID={cellValues.row.sampleItemID}
          />
        )}
        {/* Conditionally render Chef approval details if they exist */}
        {cellValues.row.userApproval && (
          <Grid item xs={12} sm={12} mt={2}>
            <Typography
              style={{
                fontSize: "16px",
                marginBottom: "15px",
                marginTop: "10px",
              }}
              gutterBottom
            >
              <b>Chef Approval:</b>
            </Typography>

            <ApprovalDetails data={cellValues.row.userApproval} />
          </Grid>
        )}
        {/* Conditionally render Executive Chef approval details if they exist */}
        {cellValues.row.execChefApproval && (
          <Grid item xs={12} sm={12} mt={2}>
            <span>
              <b>Executive Chef Approval:</b>
            </span>
            <ApprovalDetails data={cellValues.row.execChefApproval} />
          </Grid>
        )}
        {/* Conditionally render HOD approval details if they exist */}

        {cellValues.row.HODApproval && (
          <Grid item xs={12} sm={12} mt={2}>
            <span>
              <b>HOD Approval:</b>
            </span>
            <ApprovalDetails data={cellValues.row.HODApproval} />
          </Grid>
        )}
      </Collapse>
    </Box>
  );
}
